import { Select } from 'antd'
import { MyForm } from '~/components/ui/MyForm'
import {
  isHKMobile,
  isMacaoMobile,
  isMobile,
  isTaiwanMobile,
  AreaCodeEnum,
} from '~/utils'
import styles from './AreaCodeSelector.module.css'
import { MySelect } from '~/components/ui/MySelect'

export const handleMobileReg = (type?: AreaCodeEnum) => {
  if (type === AreaCodeEnum.HK) {
    return isHKMobile
  }
  if (type === AreaCodeEnum.MACAO) {
    return isMacaoMobile
  }
  if (type === AreaCodeEnum.TAIWAN) {
    return isTaiwanMobile
  }
  return isMobile
}

const options = [
  { value: AreaCodeEnum.CN, label: AreaCodeEnum.CN },
  { value: AreaCodeEnum.HK, label: AreaCodeEnum.HK },
  { value: AreaCodeEnum.MACAO, label: AreaCodeEnum.MACAO },
  { value: AreaCodeEnum.TAIWAN, label: AreaCodeEnum.TAIWAN },
]

const AreaCodeSelector: React.FC<{
  onChange?: (value: AreaCodeEnum) => void
}> = ({ onChange }) => {
  return (
    <div className={styles.wrapper}>
      <MyForm.Item name="areaCode" noStyle initialValue={AreaCodeEnum.CN}>
        <Select onChange={val => onChange?.(val as AreaCodeEnum)}>
          {options.map(it => (
            <Select.Option key={it.value} value={it.value}>
              {it.label}
            </Select.Option>
          ))}
        </Select>
      </MyForm.Item>
    </div>
  )
}
export default AreaCodeSelector
